export default __webpack_public_path__ + "static/media/AlreadyScanned.50775474.mp3";